<template>
  <picture :class="className">
    <source
      v-for="(source, index) in localSources"
      :key="index"
      :media="source.media"
      :srcset="source.srcset"
      :sizes="source.sizes">
    <img
      :src="img.src"
      :srcset="img.srcset"
      :sizes="img.sizes"
      :class="imgClassName">
  </picture>
</template>

<script>
/*
Pict.vue is a wrapper around the html 5 picture
(https://developer.mozilla.org/en-US/docs/Web/HTML/Element/picture) tag,
to easily create responsive images.
As props it will take different srcsets:
- default: a srcset for the default image to be apply. Usually it is the one used for large screens.
- sources: an array of srcsets
(https://developer.mozilla.org/en-US/docs/Web/HTML/Element/source#attr-srcset)
A srcset is an object with the following structure:
- src: the default image URL to display.
- srcsets: an object of pairs pairs with the pixel density descriptor as key and the URL as value.
- media: the breakpoint key as described in the design system, until which the srcset must be applied.
Ex:
{
  media: "xs",
  src: "://url-to-1x-image",
  srcset: {
    "2x": "://url-to-2x-image"
  }
}
*/
import bemBlockModifiers from "/utils/bem-block-modifiers";

export default {
  name: "Pict",
  props: {
    blockName: { type: String, default: null },
    modifiers: { type: Array, default: null },
    sources: { type: Array, default: () => [] },
    default: { type: Object, required: true }
  },
  computed: {
    className() {
      const classNames = [bemBlockModifiers("pict", this.modifiers)];
      if (this.blockName) {
        classNames.push(`${this.blockName}__picture`);
      }
      return classNames;
    },
    imgClassName() {
      const classNames = ["pict__image"];
      if (this.blockName) {
        classNames.push(`${this.blockName}__image`);
      }
      return classNames;
    },
    localSources() {
      return this.sources.map(source => {
        return {
          media: this.getMedia(source.media),
          srcset: this.getSrcset(source.srcset, source.src),
          sizes: source.sizes
        };
      });
    },
    img() {
      return {
        src: this.default.src,
        srcset: this.getSrcset(this.default.srcset),
        sizes: this.default.sizes
      };
    }
  },
  methods: {
    getSrcset(srcset) {
      return Object.keys(srcset).map(key => {
        return `${srcset[key]} ${key}`;
      }).join(", ");
    },
    getMedia(media) {
      switch (media) {
      case "xs":
        return "(max-width: 415px)";
      case "s":
        return "(max-width: 767px)";
      case "m":
        return "(max-width: 1023px)";
      default:
        return media;
      }
    }
  }
};
</script>
